import React from "react";
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import BreadcrumbOne from "../elements/breadcrumb/BreadcrumbOne";
import SectionTitle from "../elements/sectionTitle/SectionTitle";

import PortfolioFive from "../elements/portfolio/portfolioFive";


const PortfolioFull = () => {
    try {
        return (
            <>
                <SEO
                    pageKey="portfolio"
                    title="Portfolio | Software & Mobile App Projects — Jaz Infotech"
                    description="Software and mobile app projects delivered by Jaz Infotech in Tirunelveli."
                    canonical="https://jazinfotech.com/portfolio"
                />
                <Layout>

                    <BreadcrumbOne 
                        title="Software &amp; Mobile App Projects <br/> by Jaz Infotech"
                        rootUrl="/"
                        parentUrl="Home"
                        currentUrl="Portfolio"
                        paddingClass="ptb--80"
                    />
                    
                    <div className="main-content">
                        <div className="rwt-portfolio-area rn-section-gap">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                            <SectionTitle
                                                textAlign = "text-center"
                                                radiusRounded = ""
                                                subtitle = "Portfolio "
                                                title = "Our Software & Mobile App Portfolio"
                                                description = ""
                                            />
                                    </div>
                                </div>
                                <PortfolioFive Column="col-lg-6 col-md-6 col-sm-12 col-12 mt--30 portfolio" />
                            </div>
                        </div>
                    </div>
                </Layout>
            </>
        )
    } catch (error) {
        console.error('PortfolioFull render error:', error);
        return (
            <>
                <SEO pageKey="portfolio" />
                <Layout>
                    <div className="main-content">
                        <div className="rwt-portfolio-area rn-section-gap">
                            <div className="container">
                                <div style={{ textAlign: 'center', padding: '40px' }}>
                                    <h2>Error Loading Portfolio</h2>
                                    <p>{error.message}</p>
                                    <p style={{ fontSize: '14px', color: '#666' }}>Please check the browser console for details.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Layout>
            </>
        );
    }
}
export default PortfolioFull;
